import {
  format,
  formatDistanceToNow,
  isWithinInterval,
  parseISO,
  subHours
} from 'date-fns'

export const DATE_FORMAT = 'MMMM do, yyyy'

export const formatDateFromISOString = (dateString: string) =>
  format(parseISO(dateString), DATE_FORMAT)

export const formatDate = (date: Date, formatTemplate?: string) =>
  format(date, formatTemplate ?? DATE_FORMAT)

export const formatDateAndTime = (
  date: Date,
  { includeOn } = { includeOn: false }
) => {
  const now = new Date()
  if (
    isWithinInterval(date, {
      start: subHours(now, 24),
      end: now
    })
  ) {
    return formatDistanceToNow(date, { addSuffix: true })
  }
  return `${includeOn ? 'on ' : ''}${format(date, 'M/d/yyyy h:mm:ss a')}`
}
